import styled from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Link from '@atoms/Link/Link';
import Config from '@config';

export const StyledUspWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${rem(44)};
  background-color: ${variables.colors.white};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    justify-content: space-between;
  }
`;

export const StyledUspItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;
`;

export const StyledUspLink = styled(Link)`
  display: inline-flex;
  align-items: center;
`;

export const StyledUspItemWrapper = styled.div`
  display: flex;
  align-items: center;
`;
